module.exports = __webpack_public_path__ + "static/media/Ghinwa.37fb303f.jpeg";